import React, { Component } from 'react';
import Alert from './Alert';

const Api = require('./Config');

export default class Hl7Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lines: [],
      startDate: '',
      endDate: '',
      loading: false,
    };
  }

  doRefresh() {
    this.setState({ lines: [], loading: true });
    Api.getHl7Logs()
      .then((lines) => {
        this.setState({ lines, loading: false });
      })
      .catch((err) => {});
  }

  componentDidMount() {
    this.doRefresh();
  }

  getFileDesp(line) {
    if (line.filetype == 'PDF') {
      return (
        <a
          href={`${Api.getHost()}docportal_api/getSftpFile.php?FILE_NAME=${line.filename}&PMHID=${line.PMHID}`}
          target="blank"
        >
          {line.filename}
        </a>
      );
    }
    return (
      <a
        style={{ cursor: 'pointer' }}
        onClick={() => {
          this.alert.open(
            'HL7 Content',
            <textarea disabled style={{ width: '100%', height: 300 }}>
              {line.file_content}
            </textarea>
          );
        }}
      >
        {line.filename}
      </a>
    );
  }

  render() {
    return (
      <div>
        <div>
          <button
            disabled={this.state.loading}
            onClick={() => {
              this.doRefresh();
            }}
            className="btn btn-primary"
          >
            Refresh
          </button>
        </div>
        <div>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>T Code</th>
                <th>File Name</th>
                <th>Created</th>
                <th>Deleted</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lines.map((line, index) => (
                <tr key={`${line.id}::${index}`}>
                  <td>{index + 1}</td>
                  <td>{line.t_code}</td>
                  <td>{this.getFileDesp(line)}</td>
                  <td>{line.created_date}</td>
                  <td>{line.deleted_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
      </div>
    );
  }
}
